import { FC, memo } from 'react';
import { NavLink } from 'react-router-dom';
import Tooltip from 'antd/lib/tooltip';

import { userSettingsByKeySelector } from 'store/selectors/userSelectors';
import { ILeftPanelMenu } from 'hooks/useLeftPanelMenus';
import { useTypedSelector } from 'hooks/useTypedSelector';
import { LeftPanelMenuItemStyled } from 'components/LeftPanel/styled';

const key = 'isCollapsedLeftPanel';

const LeftPanelMenuItem: FC<ILeftPanelMenu> = ({ name, path, icon: Icon, count }) => {
  const isCollapsedLeftPanel = useTypedSelector((state) => userSettingsByKeySelector({ key, ...state }));

  return (
    <LeftPanelMenuItemStyled isCollapsedLeftPanel={isCollapsedLeftPanel}>
      <Tooltip placement="right" title={name} trigger={isCollapsedLeftPanel && 'hover'}>
        <NavLink
          to={path}
          className="cursor-pointer flex items-center h-[50px] text-black-0 dark:text-black-30 clickable"
        >
          <Icon className="mx-2.5 min-w-[24px] w-6" />
          {!isCollapsedLeftPanel && name}
          {(!isCollapsedLeftPanel && !!count) && (
            <span className="bg-orange-50 rounded-3xl text-11 text-black-0 px-2.5 py-0.5 ml-2.5 dark:text-black-85">
              {count}
            </span>)}
        </NavLink>
      </Tooltip>
    </LeftPanelMenuItemStyled>
  );
};

export default memo(LeftPanelMenuItem);
